module.exports = __webpack_public_path__ + "assets/img/be07-ms.svg";